module.exports = __webpack_public_path__ + "img/sunhongyin.9eb55302.jpg";